var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
var loadedThemes = new Set();
var BaseChart = function (_a) {
    var option = _a.option, className = _a.className, style = _a.style, theme = _a.theme, eventHandlers = _a.eventHandlers, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var containerRef = useRef(null);
    var chartInstanceRef = useRef(null);
    var echartsModuleRef = useRef(null);
    var eventsRef = useRef(eventHandlers);
    var _c = useState(false), ready = _c[0], setReady = _c[1];
    eventsRef.current = eventHandlers;
    var applyEvents = function () {
        var instance = chartInstanceRef.current;
        var handlers = eventsRef.current;
        if (!instance) {
            return;
        }
        instance.off();
        if (!handlers) {
            return;
        }
        Object.entries(handlers).forEach(function (_a) {
            var event = _a[0], handler = _a[1];
            if (typeof handler === "function") {
                instance.on(event, function (params) { return handler(params, instance); });
            }
        });
    };
    useEffect(function () {
        var disposed = false;
        var initChart = function () { return __awaiter(void 0, void 0, Promise, function () {
            var mod, echarts, themeName, resolvedTheme, instance, klineSeries, error_1;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!containerRef.current) {
                            return [2 /*return*/];
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 4, , 5]);
                        if (!!echartsModuleRef.current) return [3 /*break*/, 3];
                        return [4 /*yield*/, import("echarts")];
                    case 2:
                        mod = _e.sent();
                        echartsModuleRef.current = (_a = mod.default) !== null && _a !== void 0 ? _a : mod;
                        _e.label = 3;
                    case 3:
                        if (disposed || !containerRef.current) {
                            return [2 /*return*/];
                        }
                        echarts = echartsModuleRef.current;
                        // 仅在外部以对象形式传入主题时进行注册，避免对特定路径的硬依赖
                        if (theme && typeof theme === "object") {
                            themeName = theme.name || "custom-theme";
                            if (!loadedThemes.has(themeName)) {
                                try {
                                    echarts.registerTheme(themeName, theme);
                                    loadedThemes.add(themeName);
                                }
                                catch (error) {
                                    if (process.env.NODE_ENV !== "production") {
                                        console.warn("[CompsChart] \u6CE8\u518C\u4E3B\u9898\u5931\u8D25:", error);
                                    }
                                }
                            }
                        }
                        resolvedTheme = typeof theme === "object"
                            ? theme.name || "custom-theme"
                            : typeof theme === "string" && loadedThemes.has(theme)
                                ? theme
                                : undefined;
                        instance = echarts.init(containerRef.current, resolvedTheme);
                        chartInstanceRef.current = instance;
                        setReady(true);
                        // 调试：检查传递给ECharts的配置
                        if (process.env.NODE_ENV === 'development') {
                            klineSeries = (_b = option.series) === null || _b === void 0 ? void 0 : _b.find(function (s) { return s.type === 'candlestick'; });
                            if (klineSeries) {
                                console.log('[CompsChart] 传递给ECharts的K线图配置:', {
                                    id: klineSeries.id,
                                    type: klineSeries.type,
                                    barWidth: klineSeries.barWidth,
                                    barMaxWidth: klineSeries.barMaxWidth,
                                    itemStyle: klineSeries.itemStyle,
                                    dataLength: (_c = klineSeries.data) === null || _c === void 0 ? void 0 : _c.length,
                                    firstDataPoint: (_d = klineSeries.data) === null || _d === void 0 ? void 0 : _d[0],
                                });
                            }
                        }
                        instance.setOption(option, true);
                        applyEvents();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _e.sent();
                        console.error("[CompsChart] 初始化 ECharts 失败", error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        initChart();
        return function () {
            disposed = true;
            setReady(false);
            if (chartInstanceRef.current) {
                chartInstanceRef.current.dispose();
                chartInstanceRef.current = null;
            }
        };
    }, [theme]);
    useEffect(function () {
        var instance = chartInstanceRef.current;
        if (!instance || !ready) {
            return;
        }
        instance.setOption(option, true);
    }, [option, ready]);
    useEffect(function () {
        var instance = chartInstanceRef.current;
        if (!instance || !ready) {
            return;
        }
        applyEvents();
    }, [eventHandlers, ready]);
    useEffect(function () {
        var instance = chartInstanceRef.current;
        if (!instance) {
            return;
        }
        if (loading) {
            instance.showLoading("default");
        }
        else {
            instance.hideLoading();
        }
    }, [loading]);
    useEffect(function () {
        var handleResize = function () {
            var _a;
            (_a = chartInstanceRef.current) === null || _a === void 0 ? void 0 : _a.resize();
        };
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (_jsx("div", { ref: containerRef, className: className, style: __assign({ width: "100%", height: "100%", minHeight: 240 }, style) }));
};
export default BaseChart;
